<template>
    <b-container class="container-panel">
        <LanguageSelection></LanguageSelection>
        <b-card no-body>
            <b-card-header>
                <h4>{{$t('AMOUNT_TO_PAY')}}</h4>
                <ul v-show="showHeader">
                    <li class="mt-1">{{customerBalance}}</li>
                    <li v-show="avoidDisconnectAmount != 0">{{avoidDisconnectMessage}}</li>
                    <li v-show="showReinstate">{{reinstateMessage}}</li>
                    <li v-show="paymentPlanBalance != 0">{{paymentPlanBalanceMessage}}</li>
                </ul>
            </b-card-header>
            <b-card-body>
                <b-form class="mt-3" @submit.stop.prevent>
                    <b-form-group>
                        <b-form-radio v-model="radio" name="some-radios" v-if="balanceInfo.balanceGrace != 0" :value="balanceInfo.balanceGrace">{{ $t('REINSTATE_AMOUNT') }} ${{balanceInfo.balanceGrace}}</b-form-radio>
                        <b-form-radio v-model="radio" name="some-radios" v-if="balanceInfo.pastDueBalance != 0" :value="balanceInfo.pastDueBalance">{{$t('PAST_DUE')}} ${{balanceInfo.pastDueBalance}}</b-form-radio>
                        <b-form-radio v-model="radio" name="some-radios" v-if="balanceInfo.currentBalance  != 0" :value="balanceInfo.currentBalance">{{$t('TOTAL_ACCOUNT_BALANCE')}} ${{balanceInfo.currentBalance}}</b-form-radio>
                        <b-form-radio v-model="radio" name="some-radios" v-if="paymentPlanBalance != 0 && custBalanceInfo.customerBalanceCurrentDue  != 0" :value="custBalanceInfo.customerBalanceCurrentDue">{{$t('CURRENT_BALANCE_DUE')}} ${{custBalanceInfo.customerBalanceCurrentDue}}</b-form-radio>
                        <b-form-radio v-model="radio" name="some-radios" v-if="avoidDisconnectAmount != 0" :value="avoidDisconnectAmount">{{$t('AVOID_DISCONNECT')}} ${{avoidDisconnectAmount}}</b-form-radio>
                        <b-form-radio v-model="radio" name="some-radios" value="otherAmount">{{$t('OTHER_AMOUNT')}}</b-form-radio>
                    </b-form-group>
                    <b-form-group v-if="radio == 'otherAmount'">
                        <b-input v-model="otherAmount" :state="preValidateAmount" id="amount-to-pay"></b-input>
                        <b-form-invalid-feedback :state="preValidateAmount">{{$t('VALID_AMOUNT')}}</b-form-invalid-feedback>
                    </b-form-group>
                    <hr />
                    <b-form-checkbox class="mt-3"
                                     id="waiveCCFee"
                                     v-model="waiveCCFee"
                                     name="waiveCCFee"
                                     v-show="showCCWaive">
                        {{waiveCCFeeMessage}}
                    </b-form-checkbox>
                    <b-form-checkbox class="mt-3"
                                     id="waiveAgentFee"
                                     v-model="waiveAgentFee"
                                     name="waiveAgentFee"
                                     v-show="showAgentWaive">
                        {{waiveAgentFeeMessage}}
                    </b-form-checkbox>
                    <hr />

                </b-form>
                <b-button @click="validate" class="mt-3" :disabled="disablePayButton">{{$t('PAY_NOW')}}</b-button>
                <b-form-invalid-feedback :state="warnCredit">{{creditWarning}}</b-form-invalid-feedback>
            </b-card-body>
            <b-card-footer>
                {{$t('ENROLL_AUTOPAY')}}
            </b-card-footer>
        </b-card>
    </b-container>
</template>

<script>
    import Repo from '../repo';
    import { mapGetters } from 'vuex';
    import i18n from '../localization';
    import LanguageSelection from '../components/LanguageSelection.vue';

    export default {
        name: "Bluenet",
        components: { LanguageSelection },
        data: () => ({
            radio: '',
            agent: '',
            otherAmount: 0,
            waiveCCFee: false,
            waiveAgentFee: false,
            ccFee: 2.50,
            agentFee: 2.50,
            state: '',
            provider: 0,
            enrollAutopay: false,
            balanceInfo: {},
            custBalanceInfo: null,
            avoidDisconnectInfo: [],
            showHeader: false
        }),
        computed: {
            ...mapGetters({
                customer: 'lobby/quickPayCustomer',
                paymentConfiguration: 'lobby/paymentConfiguration'
            }),
            warnCredit() {
                if (this.balanceInfo.currentBalance || this.balanceInfo.currentBalance == 0) {
                    return !(this.otherAmount > this.balanceInfo.currentBalance);
                } else {
                    return true;
                }
            },
            creditWarning() {
                return this.canOverpayAutopay ? i18n.t('CREDIT_WARNING') : i18n.t('INELIGIBLE_OVERPAY');
            },
            canOverpayAutopay() {
                if (this.customer && this.customer.statusCode && this.customer.statusCode == "C") {
                    //cancelled customers cannot overpay
                    return false;
                }
                //only NICOR, TX, and CANADA customers can overpay. This lobby does not take Canada payments
                if (this.provider == 294) {
                    return true; //294 is NICOR
                }
                if (this.state == 'TX') {
                    return true;
                }
                return false;
            },
            disablePayButton() {
                if (this.radio == "") {
                    return true;
                }
                if (this.radio !== "otherAmount" && this.radio < 1) {
                    return true;
                }
                if (this.radio == "otherAmount" && this.otherAmount < 1) {
                    return true;
                }
                if (!this.canOverpayAutopay && this.balanceInfo.currentBalance < this.otherAmount) {
                    return true;
                }

                if (this.customer.statusCode == "C" && this.balanceInfo.currentBalance < this.otherAmount) {
                    return true;
                }
                if (this.radio == "otherAmount" && this.otherAmount >= 1) {
                    return false;
                }

                return false;
            },
            customerRequest() {
                return { CustomerNumber: this.$route.params.customerNumber, ANumber: this.$route.params.aNumber };
            },
            avoidDisconnectMessage() {
                let message = i18n.t('AVOID_DISCONNECT_MESSAGE');
                if (this.avoidDisconnectAmount > 0) {
                    return message.replace("{0}", this.avoidDisconnectAmount);
                } else {
                    return 0;
                }
            },
            avoidDisconnectAmount() {
                if (this.avoidDisconnectInfo.length == 1) {
                    return this.avoidDisconnectInfo[0].amountToAvoidDisconnect;
                }
                else if (this.avoidDisconnectInfo.length > 0) {
                    return this.avoidDisconnectInfo.reduce((info1, info2) => info1.amountToAvoidDisconnect + info2.amountToAvoidDisconnect);
                } else {
                    return 0;
                }
            },
            paymentPlanBalance() {
                if (this.custBalanceInfo != null && this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance > 0) {
                    return this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance;
                } else {
                    return 0;
                }
            },
            reinstateMessage() {
                let message = i18n.t('REINSTATE_AMOUNT_MESSAGE');
                if (this.balanceInfo.balanceGrace > 0 && this.balanceInfo.hasTreatment) {
                    return message.replace("{0}", this.balanceInfo.balanceGrace);
                } else {
                    return -1;
                }
            },
            paymentPlanBalanceMessage() {
                if (this.custBalanceInfo != null && this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance > 0 && this.custBalanceInfo.balanceSummaryModel.paymentPlanBalanceDue == 0) {
                    let message = i18n.t('PAYMENTPLAN_BALANCE_AMOUNT_MESSAGE');
                    return message.replace("{0}", this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance);
                }
                else if (this.custBalanceInfo != null && this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance > 0 && this.custBalanceInfo.balanceSummaryModel.paymentPlanBalanceDue > 0) {
                    let message = i18n.t('PAYMENTPLAN_BALANCE_AMOUNT_DUE_MESSAGE');
                    return message.replace("{0}", this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance).replace("{1}", this.custBalanceInfo.balanceSummaryModel.paymentPlanBalanceDue);
                }
                else {
                    return 0;
                }
            },
            showReinstate() {
                if (this.balanceInfo.balanceGrace > 0 && this.balanceInfo.hasTreatment) {
                    return true;
                } else {
                    return false;
                }
            },
            customerBalance() {
                if (this.balanceInfo.pastDueBalance > 0) {
                    return i18n.t('CURRENT_BALANCE_PAST_DUE_MESSAGE').replace("{0}", this.balanceInfo.currentBalance).replace("{1}", this.balanceInfo.pastDueBalance);
                } else {
                    return i18n.t('CURRENT_BALANCE_MESSAGE').replace("{0}", this.balanceInfo.currentBalance);
                }
            },
            preValidateAmount() {
                if (this.customer.statusCode == "C" && this.balanceInfo.currentBalance < this.otherAmount) {
                    return false
                }
                return this.otherAmount >= 1;
            },
            waiveCCFeeMessage() {
                return i18n.t('WAIVE_CCFEE').replace("{0}", this.ccFee.toFixed(2));
            },
            waiveAgentFeeMessage() {
                return i18n.t('WAIVE_AGENTFEE').replace("{0}", this.agentFee.toFixed(2));
            },
            showAgentWaive() {
                return this.agentFee > 0;
            },
            showCCWaive() {
                return this.ccFee > 0;
            }
        },
        mounted() {
            this.$store.dispatch('shell/updateLanguageFromQuery', this.$route.query.lang);
            Repo.AuthenticationService.ValidateToken({ Token: this.$route.params.authToken }).then(res => {
                if (res && res.success) {
                    this.agent = res.userId;
                    this.validateAccountInfo().then(isValid => {
                        if (isValid) {
                            Repo.QuickPayService.GetAllBalancesByCustomerNumber(this.customerRequest).then(res => this.balanceInfo = res);
                            Repo.QuickPayService.GetCustomerBalance({ CustomerNbr: this.customerRequest.CustomerNumber }).then(res => this.custBalanceInfo = res);
                            Repo.QuickPayService.GetAmountToAvoidDisconnect(this.customerRequest).then(res => this.avoidDisconnectInfo = res.avoidDisconnectInformation);
                            Repo.QuickPayService.IsCCFeeCharged(this.customerRequest).then(res => {
                                if (!res.isCharged) {
                                    this.ccFee = 0.00;
                                }
                            });
                            Repo.QuickPayService.IsAgentFeeCharged(this.customerRequest).then(res => {
                                if (!res.isCharged) {
                                    this.agentFee = 0.00;
                                }
                            })
                            Repo.QuickPayService.GetStatusCode(this.customerRequest).then(res => {
                                this.$store.dispatch('lobby/setQuickPayCustomer', { statusCode: res.statusCode });
                            });
                            this.getCustomerProviderAndState();
                        }
                    })
                } else {
                    this.$store.dispatch('shell/addErrorMessages', i18n.t('NOT_AUTHENTICATED'));
                }
                this.showHeader = true;
            })
        },
        methods: {
            validate: async function () {
                this.getPaymentToken();
            },
            validateAccountInfo: async function () {
                var req = { ANumber: this.$route.params.aNumber, CustomerNumber: this.$route.params.customerNumber };
                return this.$store.dispatch('lobby/getCustomerName', req);
            },
            getCustomerProviderAndState: async function () {
                Repo.QuickPayService.GetCustomerProviderAndState(this.customerRequest).then(res => {
                    this.state = res.providerStateCd;
                    this.provider = res.providerID;
                });
            },
            getPaymentToken() {
                var additionalParameters = Object.assign(
                    {},
                    {
                        CreditCardProcessingFee: this.ccFee,
                        AgentProcessingFee: this.agentFee,
                        WaiveAgentFee: this.waiveAgentFee,
                        WaiveCCFee: this.waiveCCFee,
                        CanEnrollAutoPay: this.canOverpayAutopay,
                        Agent: this.agent,
                        CustomerNumber: this.$route.params.customerNumber,
                        DialogId: this.$route.query.dialogId
                    }
                );
                var body = Object.assign(
                    {},
                    {
                        Amount: this.radio == "otherAmount" ? this.otherAmount : this.radio,
                        AccountHolderName: this.paymentConfiguration.accountName,
                        ExternalKeyValue: this.$route.params.aNumber,
                        ExternalKeyType: "CUSTOMER",
                        PaymentCampaignCode: "BLUENET",
                        CallBackUrl: this.$route.query.CallBackUrl,
                        AdditionalParameters: additionalParameters,
                        DisplayLanguageOptions: ["en", "sp"],
                        CountryCode: "US"
                    }
                );
                this.$store.dispatch("lobby/getPaymentToken", body);
            }
        }
    };
</script>
